import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface UnreadBadgeProps {
  count: number;
  className?: string;
}

/**
 * Compact unread badge for sidebar/nav use. Renders nothing when count is 0.
 * Shows "99+" for counts >= 100.
 */
export function UnreadBadge({ count, className }: UnreadBadgeProps) {
  const { t } = useTranslation("inbox");
  if (count <= 0) return null;
  const label = count >= 100 ? "99+" : String(count);
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-primary px-1.5 text-[10px] font-semibold leading-none text-primary-foreground min-w-[18px] h-[18px]",
        className,
      )}
      aria-label={t("unreadBadge.ariaLabel", { count })}
    >
      {label}
    </span>
  );
}
